









import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "CContentTop",
  components: {}
})
export default class CContentTop extends Vue {
  @Prop() label!: string;
}
